import * as yup from 'yup';

import { i18n } from 'i18n';
import { AddEditContactFormValues } from '../types';

export const getValidationSchema = (): yup.SchemaOf<AddEditContactFormValues> =>
  yup.object({
    name: yup
      .string()
      .required(i18n.t('messages.contacts:nameRequired'))
      .trim(),
    title: yup.string().trim(),
    email: yup.string().email(i18n.t('common:invalidEmail')).trim(),
    phones: yup.array().of(
      yup.object().shape({
        phone: yup
          .string()
          .min(16, i18n.t('messages.contacts:phoneNumberTenDigits'))
          .max(16, i18n.t('messages.contacts:phoneNumberTenDigits'))
          .trim(),
        type: yup.string(),
      })
    ),
    groups: yup.array().of(
      yup.object().shape({
        label: yup.string().trim(),
        checked: yup.boolean(),
      })
    ),
    nameYourGroup: yup.string().trim(),
    website: yup.string().trim(),
    notes: yup.string().trim(),
    address: yup.string().trim(),
  });
